<ng-container *ngIf="page_summary_loaded">
	<div class="new-summary-section">
    <div class="each-new-summary-section" style="background: #F2F2F2;" *ngIf="(selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
			<p class="each-new-summary-section-count">{{commonService.abbreviateNumber(page_summary_data.uploaded_leads)}}</p>
			<p class="each-new-summary-section-label">Total Uploaded Leads</p>
		</div>
		<div class="each-new-summary-section">
			<p class="each-new-summary-section-count">
				{{ commonService.abbreviateNumber(page_summary_data.total_leads) }}
			</p>
			<p class="each-new-summary-section-label">Leads</p>
		</div>
		<div class="each-new-summary-section">
			<p class="each-new-summary-section-count">
				{{APP_CONSTANTS.CURRENCY_SYMBOL}}{{ commonService.abbreviateNumber(page_summary_data.total_opportunity) }}
			</p>
			<p class="each-new-summary-section-label">
				Predicted Potential Opportunity
			</p>
		</div>
		<div class="each-new-summary-section" *ngIf="(selected_tab != 'MAGI') && (user_details.role.role != 8 && user_details.role.role != 13 && user_details.role.role != 14)">
			<p class="each-new-summary-section-count">
				{{ page_summary_data.avg_wallet_share }}
			</p>
			<p class="each-new-summary-section-label">
				Additional Book Value
			</p>
		</div>

		<div class="each-new-summary-section">
			<div class="each-new-summary-section-switch">
				<mat-slide-toggle
				class="graph-action-switch"
				[(ngModel)]="show_analysis"
				></mat-slide-toggle>
			</div>
			<p class="each-new-summary-section-label">
				View Analysis
			</p>
		</div>

		<div class="each-new-summary-section">
			<div class="each-new-summary-section-switch">
				<mat-slide-toggle
				class="graph-action-switch"
				[(ngModel)]="show_graphical_representation"
				(change)="toggleGraphs()"
				></mat-slide-toggle>
			</div>
			<p class="each-new-summary-section-label">
				Graphical Representation
			</p>
		</div>
	</div>

	<!-- <ng-container>
		<app-agent-one-view [type]="type"></app-agent-one-view>
	</ng-container> -->

	<ng-container *ngIf="page_graph_data_loaded && show_analysis">
		<!-- <div class="page-graphs-section">
			<div class="opp-breakdown-section">
				<div class="page-graph-heading-section">
					<img src="assets/events.png" class="page-graph-heading-icon" />
					<span>Opportunities Breakdown</span>
				</div>
				<div class="each-page-graph-content">
					<div id="breakdown-graph"></div>
				</div>
			</div>
			<div class="opp-detail-graph-section">
				<div class="each-page-graph-block">
					<div class="page-graph-heading-section">
						<img src="assets/events.png" class="page-graph-heading-icon" />
						<span>Rule Based Triggers Breakdown</span>
						<div class="section-heading-tooltip-block">
							<img src="assets/info-black.png" />
							<div class="section-heading-tooltip-section" style="width: 400px; left: unset; right: 0;">
								<div class="module-page-information-section" *ngFor="let section of rule_based_tooltip_section">
									<div class="each-module-page-information-section">
										<p class="each-module-page-information-heading">{{section.name}}</p>
									</div>
									<ng-container *ngIf="section.sub_sections">
										<ng-container *ngFor="let sub_section of section.sub_sections; let index = index">
											<div class="each-module-page-information-sub-section">
												<p class="each-module-page-information-heading">{{index + 1}}. {{sub_section.value}}</p>
											</div>
										</ng-container>
									</ng-container>
								</div>
							</div>
						</div>
					</div>
					<div class="each-page-graph-content">
						<div id="rule-based-breakdown-graph"></div>
					</div>
				</div>
				<div class="each-page-graph-block">
					<div class="page-graph-heading-section">
						<img src="assets/events.png" class="page-graph-heading-icon" />
						<span>AI Triggers Breakdown</span>
						<div class="section-heading-tooltip-block">
							<img src="assets/info-black.png" />
							<div class="section-heading-tooltip-section" style="width: 400px; left: unset; right: 0;">
								<div class="module-page-information-section" *ngFor="let section of ai_based_tooltip_section">
									<div class="each-module-page-information-section">
										<p class="each-module-page-information-heading">{{section.name}}</p>
									</div>
									<ng-container *ngIf="section.sub_sections">
										<ng-container *ngFor="let sub_section of section.sub_sections; let index = index">
											<div class="each-module-page-information-sub-section">
												<p class="each-module-page-information-heading">{{index + 1}}. {{sub_section.value}}</p>
											</div>
										</ng-container>
									</ng-container>
								</div>
							</div>
						</div>
					</div>
					<div class="each-page-graph-content">
						<div id="ai-triggers-breakdown-graph"></div>
					</div>
				</div>
			</div>
		</div> -->
		<!-- <app-stage-process-analysis [opp_type]="'non_members'" [stepper_stage]="stepper_stage" [selected_opportunity_period]="selected_opportunity_period" (analysisChanged)="analysisChanged($event)"></app-stage-process-analysis> -->
		<app-stage-process-analysis-v2 [opp_type]="'non_members'" [stepper_stage]="stepper_stage" [selected_opportunity_period]="selected_opportunity_period" (analysisChanged)="analysisChanged($event)"></app-stage-process-analysis-v2>
	</ng-container>

	<ng-container *ngIf="page_graph_data_loaded">
		<div class="page-graphs-section" [hidden]="!show_graphical_representation">
			<ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="graphSlideConfig">
				<div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Opportunities by Year</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="opp-year-graph"></div>
					</div>
				</div>
				<!-- <div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Leads Across Various Financial Products</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="source-comparision-graph"></div>
					</div>
				</div> -->
        <div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Activities by Communication Channel</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="communication-channel-activities-graph"></div>
					</div>
				</div>
				<div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Activities by Months</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="monthly-activities-graph"></div>
					</div>
				</div>
				<div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Leads by Source</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="source-graph"></div>
					</div>
				</div>
				<div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Leads by Age Triggers</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="age-triggers-graph"></div>
					</div>
				</div>
        <div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Leads by Date Triggers</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="date-triggers-graph"></div>
					</div>
				</div>
				<div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Leads by Data Triggers</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="data-triggers-graph"></div>
					</div>
				</div>
				<div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Leads by AI Triggers</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="ai-triggers-graph"></div>
					</div>
				</div>
				<div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Leads By Propensity Score</span>
					</div>
					<div class="each-summary-graph-content">
						<div id="propensity-score-graph"></div>
					</div>
				</div>
				<!-- <div ngxSlickItem class="each-summary-graph-block">
					<div class="summary-graph-heading-section">
						<img src="assets/events.png" class="summary-graph-heading-icon" />
						<span>Leads By Region</span>
					</div>
					<div class="each-summary-graph-content">
						<highcharts-chart
						[Highcharts]="Highcharts"
						[constructorType]="chartConstructor"
						[options]="chartOptions"
						[(update)]="updateFlag"
						[oneToOne]="true"
						style="width: 100%; height: 250px; display: block"
						>
					</highcharts-chart>
				</div>
			</div> -->
		</ngx-slick-carousel>
	</div>
</ng-container>
<ng-container *ngIf="!page_graph_data_loaded && show_graphical_representation">
	<app-loader [loading_text]="'Loading Graphical Representation'"></app-loader>
</ng-container>
<!-- <div class="analysis-heading-section">
	<span>{{type}} Analysis</span>
	<div class="section-heading-tooltip-block">
		<img src="assets/info-black.png" />
		<div class="section-heading-tooltip-section">
			<p>The goal of this analysis slider is to help determine where the greatest value lies and where advisors should focus their efforts. It also aids advisors in understanding how many leads they can handle personally, how many should be reassigned to Assistant Financial Advisors (AFAs), and the remainder to be managed by the AI Advisor Assistant. This ensures that no opportunity is missed, regardless of time constraints and value limitations.</p>
			<p>The goal of this analysis slider is to help determine where the greatest value lies and where advisors should focus their efforts. It also aids advisors in understanding how many leads they can handle personally, how many should be reassigned to Junior Advisors, and the remainder to be managed by the AI Advisor Assistant. This ensures that no opportunity is missed, regardless of time constraints and value limitations.</p>
			<br />
			<p>The section corresponding to the analysis slider on the left displays a graphical representation of the analysis and the predicted outcomes in terms of values.</p>
		</div>
	</div>
</div>
<div class="page-summary-analysis-section">
	<div class="page-summary-analysis-calculator-section">
		<div class="each-summary-calculator-questions-section">
			<p class="each-summary-calculator-question">What Top percentage of leads would you like to work with</p>
			<div class="summary-calculator-slider-section">
				<span class="summary-calculator-slider-label">1%</span>
				<div class="summary-calculator-slider">
					<mat-slider thumbLabel [displayWith]="formatLabel" min="1" max="100" step="1"[(ngModel)]="selected_top_percentage" (input)="opportunitySliderChanged($event);" (change)="opportunitySliderStopped()"></mat-slider>
				</div>
				<span class="summary-calculator-slider-label">100%</span>
			</div>
			<div class="summary-calculator-slider-input-section">
				<input type="number" class="each-summary-calculator-question-input" [min]="1" [max]="100" [(ngModel)]="selected_top_percentage" (input)="validateSliderValue($event); opportunitySliderStopped();" />
			</div>
		</div>
		<div class="each-summary-calculator-questions-section">
			<p class="each-summary-calculator-question">With what percentage of opportunity</p>
			<div class="summary-calculator-slider-section">
				<span class="summary-calculator-slider-label">1%</span>
				<div class="summary-calculator-slider">
					<mat-slider thumbLabel [displayWith]="formatLabel" min="1" max="100" step="1"[(ngModel)]="selected_analysis_value" (input)="upsideOpportunitySliderChanged($event);" (change)="opportunitySliderStopped()"></mat-slider>
				</div>
				<span class="summary-calculator-slider-label">100%</span>
			</div>
			<div class="summary-calculator-slider-input-section">
				<input type="number" class="each-summary-calculator-question-input" [min]="1" [max]="100" [(ngModel)]="selected_analysis_value" (input)="validateSliderValue($event); opportunitySliderStopped();" />
			</div>
		</div>
		<div class="each-summary-calculator-questions-section">
			<p class="each-summary-calculator-question">Automated activities will be executed for all the identified {{type}}. As an Advisor you can start manually reaching out to top <strong>{{selected_top_percentage}}%</strong> of leads</p>
		</div>
	</div>
	<div class="page-summary-analysis-details-section">
		<div class="page-summary-analysis-details-graph-section">
			<p class="page-summary-analysis-details-heading">High Value Leads: {{selected_high_value_leads}}</p>
			<ng-container *ngIf="opportunity_graph_loaded">
				<div id="opportunity-graph"></div>
			</ng-container>
			<ng-container *ngIf="!opportunity_graph_loaded">
				<p class="page-summary-analysis-details-graph-loader">Loading Graph...</p>
			</ng-container>
		</div>
		<div class="page-summary-analysis-graph-details-section" *ngIf="opportunity_graph_loaded">
			<div class="each-page-summary-analysis-graph-details-section" *ngFor="let data of opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['data']; let index = index" [style.borderColor]="opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['colors'][index]">
				<div class="each-page-summary-analysis-graph-details">
					<p class="each-page-summary-analysis-graph-details-label">{{opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['labels'][index]}} Opportunity</p>
					<p class="each-page-summary-analysis-graph-details-count">$ {{commonService.abbreviateNumber(data)}} <span class="each-page-summary-analysis-graph-details-label" style="width: auto;">({{opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['data_percentage'][index]}}%)</span></p>
				</div>
				<div class="each-page-summary-analysis-graph-details">
					<p class="each-page-summary-analysis-graph-details-label">Additional Book Value</p>
					<p class="each-page-summary-analysis-graph-details-count">{{opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['book_value'][index]}}</p>
				</div>
				<div class="page-summary-graph-legend-section">
					<div class="page-summary-graph-legend-circle" [style.background]="opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['colors'][index]"></div>
					<span class="page-summary-graph-legend-name" [style.color]="opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['colors'][index]">Represents {{opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['labels'][index]}} Leads</span>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="page-summary-recommendation-section" *ngIf="opportunity_graph_loaded">
	<p class="each-summary-recommendation-content">By concentrating on the top <strong>{{selected_top_percentage}}%</strong> of {{type}}, you have the potential to acquire <strong>{{selected_high_value_leads}}</strong> leads, representing <strong>{{opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['data_percentage'][0]}}%</strong> of the total predicted opportunity, thereby achieving an <strong>{{opportunity_graph_data[selected_top_percentage][selected_analysis_value]['opportunity_graph']['book_value'][0]}}</strong> enhancement in the overall book value.</p>

	<p class="each-summary-recommendation-heading">Recommendation:</p>
	<p class="each-summary-recommendation-content">By strategically targeting a specific percentage of top opportunities, you can significantly increase client acquisition as detailed below:</p>
	<table class="each-summary-recommendation-table">
		<thead>
			<tr>
				<th>Top Percentage of Leads</th>
				<th>Predicted Opportunity Capture</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let recomendation of opportunity_recomendation_data">
				<td>{{recomendation.top_percentage}}</td>
				<td>{{recomendation.predicted_opportunity_capture}}</td>
			</tr>
		</tbody>
	</table>
</div> -->

<!-- <ng-container *ngIf="!opportunity_graph_loaded">
	<app-loader [loading_text]="'Loading Recommendation'"></app-loader>
</ng-container> -->

<div class="summary-table-data-section">
	<div class="summary-table-section">
		<div>
			<!-- <div class="move-records-section">
				<button class="move-records-button" (click)="openMoveRecordModal()">Move to Stage</button>
				<span class="page-modal-input-label" *ngIf="selected_table_data.length > 0">{{selected_table_data.length}} Record(s) Selected</span>
				<span class="page-modal-input-error" *ngIf="selected_table_data.length == 0 && move_record_error">Please select one or more clients to move</span>
			</div> -->
			<div class="new-table-v2-overflow">
				<div class="new-table-heading-section">
					<div class="my-4">
						<span class="new-filter-tag" *ngIf="opp_year_id != ''">
							{{ opp_year_name }}
							<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" opp_year_id = ''; opp_year_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "/>
						</span>
						<span class="new-filter-tag" *ngIf="source_type != ''">
							{{ source_type }}
							<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" source_type = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "/>
						</span>

						<span class="new-filter-tag" *ngIf="age_trigger_id != ''">
							{{ age_trigger_name }}
							<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" age_trigger_id = ''; age_trigger_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "/>
						</span>

            <span class="new-filter-tag" *ngIf="data_trigger_id != ''">
							{{ data_trigger_name }}
							<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" data_trigger_id = ''; data_trigger_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "/>
						</span>

						<span class="new-filter-tag" *ngIf="date_trigger_id != ''">
							{{ date_trigger_name }}
							<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" date_trigger_id = ''; date_trigger_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "/>
						</span>

						<span class="new-filter-tag" *ngIf="ai_trigger_id != ''">
							{{ ai_trigger_name }}
							<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" ai_trigger_id = ''; ai_trigger_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "/>
						</span>

						<span class="new-filter-tag" *ngIf="propensity_score_id != ''">
							{{ propensity_score_name }}
							<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" propensity_score_id = ''; propensity_score_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData()"/>
						</span>

						<span class="new-filter-tag" *ngIf="opp_breakdown_id != ''">
							{{ opp_breakdown_name }}
							<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" opp_breakdown_id = ''; opp_breakdown_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "
							/>
						</span>
						<span class="new-filter-tag" *ngIf="rules_breakdown_id != ''">
							{{ rules_breakdown_name }}
							<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" rules_breakdown_id = ''; rules_breakdown_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "
							/>
						</span>
						<span class="new-filter-tag" *ngIf="ai_breakdown_id != ''">
							{{ ai_breakdown_name }}
							<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" ai_breakdown_id = ''; ai_breakdown_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "
							/>
						</span>

						<span class="new-filter-tag" *ngIf="common_breakdown_id != ''">
							{{ common_breakdown_name }}
							<img src="assets/filter-tag-close.png" class="filter-close-icon" (click)=" common_breakdown_id = ''; common_breakdown_name = ''; current_pagination_page = 1; update_selected_high_value_leads = true; getTableData() "
							/>
						</span>

					</div>
					<!-- <span style="visibility: hidden;">S</span> -->
					<span>AI Explainability</span>
					<div class="section-heading-tooltip-block">
						<img src="assets/info-black.png" />
						<div class="section-heading-tooltip-section">
							<div class="module-page-information-section" *ngFor="let section of non_members_ai_explainability_sections">
								<div class="each-module-page-information-section">
									<p class="each-module-page-information-heading">{{section.name}}</p>
								</div>
								<ng-container *ngIf="section.sub_sections">
									<ng-container *ngFor="let sub_section of section.sub_sections; let index = index">
										<div class="each-module-page-information-sub-section">
											<p class="each-module-page-information-sub-heading">{{index + 1}}. {{sub_section.name}}:</p>
											<p class="each-module-page-information-sub-content">{{sub_section.value}}</p>

											<ng-container *ngIf="sub_section.sub_sections">
												<div class="each-module-page-information-sub-section" *ngFor="let sub_section of sub_section.sub_sections; let index = index">
													<p class="each-module-page-information-sub-heading">{{index + 1}}) {{sub_section.name}}:</p>
													<p class="each-module-page-information-sub-content">{{sub_section.value}}</p>
												</div>
											</ng-container>

										</div>
									</ng-container>
								</ng-container>
							</div>
						</div>
					</div>
					<div class="new-table-actions ml-4">
						<div
						class="each-action-section search-input-section"
						*ngIf="show_search"
						>
						<input
						type="text"
						placeholder="Search"
						class="search-input"
						[(ngModel)]="search_key"
						(input)="current_pagination_page = 1; getTableData()"
						/>
						<span
						class="search-input-close"
						(click)="
						show_search = false;
						search_key = '';
						current_pagination_page = 1;
						getTableData()
						"
						>&times;</span
						>
					</div>
					<div
					class="each-action-section search-icon"
					*ngIf="!show_search"
					(click)="show_search = true"
					>
					<img src="assets/search.png" class="button-icon" />
					<span>Search</span>
				</div>
				<div class="each-action-section dynamic-columns-section">
					<img
					src="assets/column-filter.png"
					class="button-icon"
					(click)="show_toggle_columns = !show_toggle_columns"
					/>
					<div class="dynamic-columns" *ngIf="show_toggle_columns">
						<div class="dynamic-column-heading-section">
							<span>Filter Columns</span>
							<span
							class="columns-close"
							(click)="show_toggle_columns = false"
							>&times;</span
							>
						</div>
						<div class="dynamic-column-content">
							<div
							class="each-column-section"
							*ngFor="let column of table_columns"
							>
							<mat-checkbox
							[checked]="column.checked == true"
							(change)="column.checked = !column.checked"
							>{{ column.name }}</mat-checkbox
							>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="each-action-section">
				<button class="secondary-button mr-0" (click)="openClientOperationModal('Add', null, {})">
					<img src="assets/add.png" class="button-icon" />
					<span>Add New Lead</span>
				</button>
			</div> -->
			<div class="each-action-section">
				<button class="secondary-button mr-0" (click)="openProspectOperation({}, 'Add')">
					<img src="assets/add.png" class="button-icon" />
					<span>Add New Prospect</span>
				</button>
			</div>
		</div>
		<div class="alphabets-filter-section">
			<p
			class="new-each-filter-alphabet"
			[ngClass]="{
				'new-filter-alphabet-selected': alphabet == selected_alphabet
			}"
			*ngFor="let alphabet of alphabets_array"
			(click)="
			current_pagination_page = 1;
			selected_alphabet = alphabet;
			getTableData()
			"
			style="margin-bottom: 8px !important"
			>
			{{ alphabet }}
		</p>
		<p
		class="clear-filter-alphabet"
		(click)="
		current_pagination_page = 1;
		selected_alphabet = '';
		getTableData()
		"
		>
		Clear
	</p>
</div>
</div>
<div class="new-table-v2-overflow">
	<table class="new-table-v2">
		<thead>
			<tr>

				<th appColumnResizable>
					<!-- <div class="record-selection-section">
						<mat-checkbox [checked]="is_selected" (change)="selectAll($event)"></mat-checkbox>
					</div> -->
					Actions
				</th>
				<!-- <th appColumnResizable>Activities</th> -->
				<th appColumnResizable>Activities</th>
				<!-- <ng-container *ngFor="let column of table_columns">
					<th appColumnResizable *ngIf="column.checked">{{ column.name }}</th>
				</ng-container> -->
				<ng-container *ngFor="let column of table_columns" [ngSwitch]="column.key">
					<ng-container *ngSwitchCase="'trigger'">
						<th appColumnResizable *ngIf="column.checked" style="width: 350px;">{{ column.name }}</th>
					</ng-container>
					<ng-container *ngSwitchCase="'trigger_condition'">
						<th appColumnResizable *ngIf="column.checked" style="width: 500px;">{{ column.name }}</th>
					</ng-container>
					<ng-container *ngSwitchDefault>
						<th appColumnResizable *ngIf="column.checked">{{ column.name }}</th>
					</ng-container>
				</ng-container>
			</tr>
		</thead>
		<ng-container *ngIf="table_data_loaded">
			<tbody *ngIf="table_data.length > 0">
				<ng-container
				*ngFor="
				let client of table_data
				| paginate
				: {
					id: 'interactions-data',
					itemsPerPage: pagination_records_limit,
					currentPage: current_pagination_page,
					totalItems: total_pagination_records
				};
				let clientIndex = index
				"
				>
				<tr>

					<td>
						<!-- <div class="record-selection-section">
							<mat-checkbox [checked]="checkIndividualSelection(client)" (change)="selectIndividual($event, client)"></mat-checkbox>
						</div> -->
						<!-- <img
						src="assets/view-tasks.png"
						class="client-table-icon"
						(click)="openClientDataModal(client)"
						/> -->
						<img
						src="assets/view-tasks.png"
						class="client-table-icon"
						(click)="showUserProfile(client)"
						/>
						<!-- <img
							src="assets/edit-client.png"
							class="client-table-icon"
							(click)="
							openClientOperationModal('Update', clientIndex, client)
							"
						/> -->
						<img
							src="assets/edit-client.png"
							class="client-table-icon"
							(click)="openProspectOperation(client, 'Edit')"
						/>
						<img
						src="assets/ic-blue-upsell.png"
						class="client-table-icon"
						(click)="openAddOpportunityModal(client)"
						[matTooltip]="'Add to Upside Opportunities'"
						*ngIf="client.advisor_recommendation == true"
						/>
						<ng-container>
							<img
							src="assets/sync-icon.png"
							class="client-table-icon"
							*ngIf="user_details.Salesforce_connected && !salesforce_sync_loader"
							(click)="salesforceSync(client)"
							[matTooltip]="'Sync Activities'"
							/>
							<img
							src="assets/sync-icon.png"
							class="client-table-icon"
							*ngIf="user_details.Salesforce_connected && salesforce_sync_loader"
							[matTooltip]="'Sync Activities'"
							/>
						</ng-container>
						<img src="assets/exclamation-icon.png" class="client-table-icon" *ngIf="client.trigger_status == 'Inactive'" [matTooltip]="client.trigger_description" />
					</td>
					<td>
						<img
						src="assets/ic-activities.png"
						class="client-table-icon"
						(click)="toggleActivityView(clientIndex)"
						/>
					</td>


					<ng-container
					*ngFor="let column of table_columns"
					[ngSwitch]="column.key"
					>
					<ng-container *ngSwitchCase="'advisor_status'">
						<td *ngIf="column.checked">
							<p class="status-tag completed-status">
								{{ client.advisor_status }}
							</p>
						</td>
					</ng-container>
					<ng-container *ngSwitchCase="'ai_rank'">
						<td class="highlight-table-cell" *ngIf="column.checked">
							{{ getTableKey(client, column) }}
						</td>
					</ng-container>
					<ng-container *ngSwitchCase="'opportunity'">
						<td class="highlight-table-cell" *ngIf="column.checked">
							{{ getTableKey(client, column) }}
						</td>
					</ng-container>
					<ng-container
					*ngSwitchCase="'predicted_wallet_share_growth'"
					>
					<td class="highlight-table-cell" *ngIf="column.checked">
						{{ getTableKey(client, column) }}
					</td>
				</ng-container>

				<ng-container *ngSwitchCase="'predicted_closure_days'">
					<td class="highlight-table-cell" *ngIf="column.checked">
						{{ getTableKey(client, column) }} Day(s)
					</td>
				</ng-container>
				<ng-container *ngSwitchCase="'recommended_products'">
					<td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getTableKey(client, column)">
						{{ getTableKey(client, column) }}
					</td>
				</ng-container>

				<ng-container *ngSwitchCase="'preferred_channel'">
					<td class="highlight-table-cell" *ngIf="column.checked" [matTooltip]="getTableKey(client, column)">
						{{ getTableKey(client, column) }}
					</td>
				</ng-container>

				<ng-container *ngSwitchCase="'trigger'">
					<td *ngIf="column.checked">
						<span [style.color]="client['trigger_type'] == 'AI' ? '#f3a638' : '#4cb64c'">{{ getTableKey(client, column) }}</span>
					</td>
				</ng-container>

				<ng-container *ngSwitchDefault>
					<td *ngIf="column.checked">
						{{ getTableKey(client, column) }}
					</td>
				</ng-container>
			</ng-container>
		</tr>
		<tr *ngIf="show_activity_view == clientIndex">
			<td colspan="9" class="page-inner-view" style="overflow: visible;">
				<app-activities [selected_user_data]="client" [selected_page_action]="'Activities'" [selected_activity_type]="1" [selected_view_type]="'View'" [activity_action_type]="'View'" [stepper_stage]="stepper_stage" (dataChanged)="changeStepper()"></app-activities>
			</td>
		</tr>
	</ng-container>
</tbody>
<tbody *ngIf="table_data.length == 0">
	<td colspan="15">
		<div class="zero-state-section">
			<span>No Data Found</span>
		</div>
	</td>
</tbody>
</ng-container>
<ng-container *ngIf="!table_data_loaded">
	<tbody>
		<tr>
			<td colspan="15" class="zero-state-section">
				<app-loader
				[loading_text]="'Loading Clients Data'"
				></app-loader>
			</td>
		</tr>
	</tbody>
</ng-container>
</table>
</div>
<div class="new-table-v2-pagination-section">
	<span class="mr-4">{{ total_pagination_records | number:'1.0-0' }} Records</span>
	<mat-select class="pagination-input" [(ngModel)]="pagination_records_limit" (selectionChange)="current_pagination_page = 1; getTableData()">
		<mat-option [value]="10">10</mat-option>
		<mat-option [value]="100">100</mat-option>
		<mat-option [value]="500">500</mat-option>
		<mat-option [value]="1000">1000</mat-option>
	</mat-select>
	<div class="new-table-v2-pagination-controls">
		<pagination-controls id="interactions-data" (pageChange)="pageChanged($event)" style="text-align: right; position: relative; top: 6px" ></pagination-controls>
	</div>
</div>
</div>
</div>
</div>
</div>

</ng-container>

<ng-container *ngIf="!page_summary_loaded">
	<app-loader [loading_text]="'Loading'"></app-loader>
</ng-container>

<ng-container *ngIf="show_prospect_operations">
	<app-prospect-operations [page_data]="prospect_operation_data" [page_operation_type]="prospect_opration_type" (prospectOperationsClosed)="closeProspectOperation($event)" (prospectOperationsUpdated)="updateProspectOperation($event)"></app-prospect-operations>
</ng-container>


<ng-template #clientDataModal>
	<div class="modal-section client-details-modal">
		<div class="modal-heading-section client-view-heading-section">
			<span class="modal-heading">Know Your Lead</span>
			<span class="client-modal-icon" (click)="closeClientDataModal()">&times;</span>
		</div>
		<div class="modal-content-section" *ngIf="!selected_modal_client_loader">
			<app-prospect-profile [prospect_data]="selected_modal_client"></app-prospect-profile>
		</div>
		<div class="modal-content-section" *ngIf="selected_modal_client_loader">
			<app-loader [loading_text]="'Loading Lead Profile'"></app-loader>
		</div>
	</div>
</ng-template>

<ng-template #addOpportunityModal>
	<div class="page-modal-section">
		<div class="modal-heading-section client-view-heading-section">
			<span class="modal-heading">Add Client to Upside Opportunities</span>
			<span class="client-modal-icon" (click)="closeAddOpportunityModal()">&times;</span>
		</div>
		<div class="modal-content-section">
			<p class="page-modal-delete-description">Are you sure you want to add this client to Opportunities?</p>
		</div>
		<div class="modal-footer-section">
			<button class="page-modal-primary-button" (click)="addOpportunity()">Yes</button>
			<button class="page-modal-secondary-button" (click)="closeAddOpportunityModal()">No</button>
		</div>
	</div>
</ng-template>


<!-- New Lead Modal -->

<ng-template #clientOperationsModal>
	<div class="modal-section large-modal">
		<div class="modal-heading-section">
			<!-- <span>{{ clientOperationType }} Prospect</span> -->
			<span>{{ clientOperationType }} Lead</span>
			<span class="modal-close-icon" (click)="closeClientOperationModal()"
			>&times;</span
			>
			<div class="progress-section">
				<div class="each-progress-step-section">
					<div
					class="each-progress-step"
					[ngClass]="{
						'each-progress-step-selected': clientOperationsProgress > 0
					}"
					>
					1
				</div>
				<p class="each-step-label">Personal and Contact Information</p>
			</div>
			<div class="each-progress-step-section">
				<div
				class="each-progress-step"
				[ngClass]="{
					'each-progress-step-selected': clientOperationsProgress > 1
				}"
				>
				2
			</div>
			<p class="each-step-label">Household and Behaviour Information</p>
		</div>
		<div class="each-progress-step-section">
			<div
			class="each-progress-step"
			[ngClass]="{
				'each-progress-step-selected': clientOperationsProgress > 2
			}"
			>
			3
		</div>
		<p class="each-step-label">Other and Additional Information</p>
	</div>
	<!-- <div class="each-progress-step-section">
		<div class="each-progress-step" [ngClass]="{'each-progress-step-selected': clientOperationsProgress > 3}">4</div>
		<p class="each-step-label">{{clientOperationType}} Product</p>
	</div> -->
</div>
</div>
<div class="modal-content-section">
	<div *ngIf="clientOperationsProgress == 1">
		<div class="each-form-section">
			<p class="each-form-heading-section">Personal Information</p>
			<div class="row">
				<div class="col-md-4">
					<div class="each-form-input-section">
						<p class="each-form-input-label">Lead ID *</p>
						<input
						type="text"
						class="each-form-input"
						[(ngModel)]="client_data.prospect_id"
						/>
					</div>
				</div>
				<div class="col-md-4">
					<div class="each-form-input-section">
						<p class="each-form-input-label">First Name *</p>
						<input
						type="text"
						class="each-form-input"
						[(ngModel)]="client_data.first_name"
						/>
					</div>
				</div>
				<div class="col-md-4">
					<div class="each-form-input-section">
						<p class="each-form-input-label">Last Name</p>
						<input
						type="text"
						class="each-form-input"
						[(ngModel)]="client_data.last_name"
						/>
					</div>
				</div>
				<div class="col-md-4">
					<div class="each-form-input-section">
						<p class="each-form-input-label">Mobile Number</p>
						<!-- <input type="text" class="each-form-input" [(ngModel)]="client_data.telephone_number" (keypress)="numberOnly($event)" maxlength="10" /> -->
						<input
						type="text"
						class="each-form-input"
						[(ngModel)]="client_data.telephone_number"
						maxlength="15"
						/>
					</div>
				</div>
				<div class="col-md-4">
					<div class="each-form-input-section">
						<p class="each-form-input-label">Email ID *</p>
						<input
						type="text"
						class="each-form-input"
						[(ngModel)]="client_data.email"
						[disabled]="clientOperationType != 'Add'"
						/>
					</div>
				</div>
				<div class="col-md-4">
					<div class="each-form-input-section">
						<p class="each-form-input-label">Gender</p>
						<mat-select
						class="each-form-input"
						[(ngModel)]="client_data.gender_id"
						>
						<mat-option [value]="''">Select Gender</mat-option>
						<mat-option
						*ngFor="let gender of genders_list"
						[value]="gender.id"
						>{{ gender.name }}</mat-option
						>
					</mat-select>
				</div>
			</div>
			<div class="col-md-4">
				<div class="each-form-input-section">
					<p class="each-form-input-label">Date of Birth *</p>
					<input
					type="text"
					class="each-form-input"
					bsDatepicker
					[maxDate]="current_date"
					[(ngModel)]="client_data.birth_date"
					[bsConfig]="{ dateInputFormat: 'MM/DD/YYYY' }"
					/>
				</div>
			</div>
			<div class="col-md-4">
				<div class="each-form-input-section">
					<p class="each-form-input-label">Education</p>
					<mat-select
					class="each-form-input"
					[(ngModel)]="client_data.education"
					>
					<mat-option [value]="''">Select Education</mat-option>
					<mat-option [value]="'School'">School</mat-option>
					<mat-option [value]="'UnderGraduate'"
					>UnderGraduate</mat-option
					>
					<mat-option [value]="'PostGraduate'">PostGraduate</mat-option>
				</mat-select>
			</div>
		</div>
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">Occupation</p>
				<mat-select
				class="each-form-input"
				[(ngModel)]="client_data.occupation"
				>
				<mat-option [value]="''">Select Occupation</mat-option>
				<mat-option [value]="'admin'">Admin</mat-option>
				<mat-option [value]="'blue-collar'">Blue Collar</mat-option>
				<mat-option [value]="'entrepreneur'">Entrepreneur</mat-option>
				<mat-option [value]="'housemaid'">Housemaid</mat-option>
				<mat-option [value]="'management'">Management</mat-option>
				<mat-option [value]="'retired'">Retired</mat-option>
				<mat-option [value]="'self-employed'"
				>Self Employed</mat-option
				>
				<mat-option [value]="'services'">Services</mat-option>
				<mat-option [value]="'student'">Student</mat-option>
				<mat-option [value]="'technician'">Technician</mat-option>
				<mat-option [value]="'unemployed'">Unemployed</mat-option>
				<mat-option [value]="'unknown'">Unknown</mat-option>
			</mat-select>
		</div>
	</div>
	<div class="col-md-4">
		<div class="each-form-input-section">
			<p class="each-form-input-label">Experience(Years)</p>
			<input
			type="text"
			class="each-form-input"
			[(ngModel)]="client_data.years_experience"
			(keypress)="numberOnly($event)"
			/>
		</div>
	</div>
	<!-- <div class="col-md-4">
		<div class="each-form-input-section">
			<p class="each-form-input-label">Status *</p>
			<mat-select class="each-form-input" [(ngModel)]="client_data.status_id">
				<mat-option [value]="''">Select Status</mat-option>
				<mat-option *ngFor="let status of status_list" [value]="status.id">{{status.name}}</mat-option>
			</mat-select>
		</div>
	</div> -->
</div>
</div>
<div class="each-form-section">
	<p class="each-form-heading-section">Contact Information</p>
	<div class="row">
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">Address Line 1</p>
				<input
				type="text"
				class="each-form-input"
				[(ngModel)]="client_data.address_line_1"
				/>
			</div>
		</div>
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">Address Line 2</p>
				<input
				type="text"
				class="each-form-input"
				[(ngModel)]="client_data.address_line_2"
				/>
			</div>
		</div>
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">City</p>
				<input
				type="text"
				class="each-form-input"
				[(ngModel)]="client_data.city"
				/>
			</div>
		</div>
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">State *</p>
				<mat-select
				class="each-form-input"
				[(ngModel)]="client_data.state_id"
				>
				<mat-option [value]="''">Select State</mat-option>
				<mat-option
				*ngFor="let state of states_list"
				[value]="state.id"
				>{{ state.name }} ({{state.code}})</mat-option
				>
			</mat-select>
		</div>
	</div>
	<div class="col-md-4">
		<div class="each-form-input-section">
			<p class="each-form-input-label">Region *</p>
			<mat-select
			class="each-form-input"
			[(ngModel)]="client_data.region_id"
			>
			<mat-option [value]="''">Select Region</mat-option>
			<mat-option
			*ngFor="let region of region_list"
			[value]="region.id"
			>{{ region.name }}</mat-option
			>
		</mat-select>
	</div>
</div>
<div class="col-md-4">
	<div class="each-form-input-section">
		<p class="each-form-input-label">ZIP Code</p>
		<input
		type="text"
		class="each-form-input"
		[(ngModel)]="client_data.zip_code"
		/>
	</div>
</div>
<div class="col-md-4">
	<div class="each-form-input-section">
		<p class="each-form-input-label">Resident Type</p>
		<mat-select
		class="each-form-input"
		[(ngModel)]="client_data.homeowner_or_renter"
		>
		<mat-option [value]="''">Select Resident Type</mat-option>
		<mat-option [value]="'HomeOwner'">HomeOwner</mat-option>
		<mat-option [value]="'Renter'">Renter</mat-option>
	</mat-select>
</div>
</div>
<div class="col-md-4">
	<div class="each-form-input-section">
		<p class="each-form-input-label">Years in Residence</p>
		<input
		type="text"
		class="each-form-input"
		[(ngModel)]="client_data.years_in_residence"
		(keypress)="numberOnly($event)"
		/>
	</div>
</div>
</div>
</div>
</div>
<div *ngIf="clientOperationsProgress == 2">
	<div class="each-form-section">
		<p class="each-form-heading-section">Household Information</p>
		<div class="row">
			<div class="col-md-4">
				<div class="each-form-input-section">
					<p class="each-form-input-label">Household ID</p>
					<input
					type="text"
					class="each-form-input"
					[(ngModel)]="client_data.household_id"
					/>
				</div>
			</div>
			<div class="col-md-4">
				<div class="each-form-input-section">
					<p class="each-form-input-label">Is Primary Contact</p>
					<mat-radio-group [(ngModel)]="client_data.is_primary_contact">
						<mat-radio-button [value]="true">Yes</mat-radio-button>
						<mat-radio-button [value]="false">No</mat-radio-button>
					</mat-radio-group>
				</div>
			</div>
			<div class="col-md-4">
				<div class="each-form-input-section">
					<p class="each-form-input-label">Marital Status</p>
					<mat-select
					class="each-form-input"
					[(ngModel)]="client_data.marital_status"
					>
					<mat-option [value]="''">Select Marital Status</mat-option>
					<mat-option [value]="'Married'">Married</mat-option>
					<mat-option [value]="'Single'">Single</mat-option>
					<mat-option [value]="'Inferred Married'">Inferred Married</mat-option>
					<mat-option [value]="'Inferred Single'">Inferred Single</mat-option>
				</mat-select>
			</div>
		</div>
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">Adults in Household</p>
				<input
				type="text"
				class="each-form-input"
				[(ngModel)]="client_data.adults_in_household"
				(keypress)="numberOnly($event)"
				/>
			</div>
		</div>
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">Children in Household</p>
				<input
				type="text"
				class="each-form-input"
				[(ngModel)]="client_data.children_in_household"
				(keypress)="numberOnly($event)"
				/>
			</div>
		</div>
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">Household Income({{APP_CONSTANTS.CURRENCY_SYMBOL}})</p>
				<input
				type="text"
				class="each-form-input"
				[(ngModel)]="client_data.household_income_in_dollars_actual"
				(keypress)="numberOnly($event)"
				/>
			</div>
		</div>
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">Individual Income in Dollars({{APP_CONSTANTS.CURRENCY_SYMBOL}}) *</p>
				<input
				type="text"
				class="each-form-input"
				[(ngModel)]="client_data.individual_income_in_dollars_actual"
				(keypress)="numberOnly($event)"
				/>
			</div>
		</div>
	</div>
</div>
<div class="each-form-section">
	<p class="each-form-heading-section">Behaviour Information</p>
	<div class="row">
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">Real Estate Investor</p>
				<mat-radio-group [(ngModel)]="client_data.real_estate_investor">
					<mat-radio-button [value]="true">Yes</mat-radio-button>
					<mat-radio-button [value]="false">No</mat-radio-button>
				</mat-radio-group>
			</div>
		</div>
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">Premium Credit Card Holder</p>
				<mat-radio-group
				[(ngModel)]="client_data.premium_credit_card_holder"
				>
				<mat-radio-button [value]="true">Yes</mat-radio-button>
				<mat-radio-button [value]="false">No</mat-radio-button>
			</mat-radio-group>
		</div>
	</div>
	<div class="col-md-4">
		<div class="each-form-input-section">
			<p class="each-form-input-label">Heavy Transactor</p>
			<mat-select
			class="each-form-input"
			[(ngModel)]="client_data.heavy_transactor"
			>
			<mat-option [value]="''">Select Heavy Transactor</mat-option>
			<mat-option [value]="'Least Likely Heavy Transactor'"
			>Least Likely Heavy Transactor</mat-option
			>
			<mat-option [value]="'Average Heavy Transactor'"
			>Average Heavy Transactor</mat-option
			>
		</mat-select>
	</div>
</div>
<div class="col-md-4">
	<div class="each-form-input-section">
		<p class="each-form-input-label">Economic Stability</p>
		<mat-select
		class="each-form-input"
		[(ngModel)]="client_data.economic_stability"
		>
		<mat-option [value]="''"
		>Select Economic Stability</mat-option
		>
		<mat-option [value]="'Well Likely Economically Stable'"
		>Well Likely Economically Stable</mat-option
		>
		<mat-option [value]="'Medium Likely Economically Stable	'"
		>Medium Likely Economically Stable
	</mat-option>
	<mat-option [value]="'Less Likely Economically Stable'"
	>Less Likely Economically Stable</mat-option
	>
	<mat-option [value]="'Lesser Likely Economically Stable	'"
	>Lesser Likely Economically Stable
</mat-option>
<mat-option [value]="'Least Likely Economically Stable'"
>Least Likely Economically Stable</mat-option
>
</mat-select>
</div>
</div>
</div>
</div>
</div>
<div *ngIf="clientOperationsProgress == 3">
	<div class="each-form-section">
		<p class="each-form-heading-section">Other Information</p>
		<div class="row">
			<div class="col-md-4">
				<div class="each-form-input-section">
					<p class="each-form-input-label">Vehicle Type</p>
					<input
					type="text"
					class="each-form-input"
					[(ngModel)]="client_data.vehicle_type"
					/>
					<!-- <mat-select class="each-form-input" [(ngModel)]="client_data.vehicle">
						<mat-option [value]="''">Select Vehicle Type</mat-option>
						<mat-option [value]="'Basic Sporty Classification'">Basic Sporty Classification</mat-option>
						<mat-option [value]="'Luxury or Upper Sporty Classification'">Luxury or Upper Sporty Classification</mat-option>
						<mat-option [value]="'Mini-Van Classification'">Mini-Van Classification</mat-option>
						<mat-option [value]="'Regular Classification Mid Sized or Small'">Regular Classification Mid Sized or Small</mat-option>
						<mat-option [value]="'Sport Utility Vehicle Classification'">Sport Utility Vehicle Classification</mat-option>
						<mat-option [value]="'Truck Classification'">Truck Classification</mat-option>
						<mat-option [value]="'Upper Classification Mid Sized or Small'">Upper Classification Mid Sized or Small</mat-option>
					</mat-select> -->
				</div>
			</div>
			<div class="col-md-4">
				<div class="each-form-input-section">
					<p class="each-form-input-label">Vehicle Count</p>
					<input
					type="text"
					class="each-form-input"
					[(ngModel)]="client_data.vehicle_count"
					(keypress)="numberOnly($event)"
					/>
				</div>
			</div>
			<div class="col-md-4">
				<div class="each-form-input-section">
					<p class="each-form-input-label">Property Type</p>
					<input
					type="text"
					class="each-form-input"
					[(ngModel)]="client_data.property_type"
					/>
					<!-- <mat-select class="each-form-input" [(ngModel)]="client_data.property_type">
						<mat-option [value]="''">Select Property Type</mat-option>
						<mat-option [value]="'2 TO 4 Unit Duplex or Triplex or Quad'">2 TO 4 Unit Duplex or Triplex or Quad</mat-option>
						<mat-option [value]="'Apartment 5Plus Units'">Apartment 5Plus Units</mat-option>
						<mat-option [value]="'Condo'">Condo</mat-option>
						<mat-option [value]="'Mobile Home'">Mobile Home</mat-option>
						<mat-option [value]="'Miscellaneous Residence Combo Store or Flat'">Miscellaneous Residence Combo Store or Flat</mat-option>
						<mat-option [value]="'Single Family Dwelling Unit'">Single Family Dwelling Unit</mat-option>
					</mat-select> -->
				</div>
			</div>
			<div class="col-md-4">
				<div class="each-form-input-section">
					<p class="each-form-input-label">
						Home Equity available for Mortgage({{APP_CONSTANTS.CURRENCY_SYMBOL}})
					</p>
					<!-- <mat-select class="each-form-input" [(ngModel)]="client_data.home_equity_available_for_mortgage_in_dollars">
						<mat-option [value]="''">Select Home Equity</mat-option>
						<mat-option [value]="'Equity 1 to 4999'">Equity 1 to 4999</mat-option>
						<mat-option [value]="'Equity 5000 to 9999'">Equity 5000 to 9999</mat-option>
						<mat-option [value]="'Equity 10000 to 19999'">Equity 10000 to 19999</mat-option>
						<mat-option [value]="'Equity 20000 to 29999'">Equity 20000 to 29999</mat-option>
						<mat-option [value]="'Equity 30000 to 49999'">Equity 30000 to 49999</mat-option>
						<mat-option [value]="'Equity 50000 to 74999'">Equity 50000 to 74999</mat-option>
						<mat-option [value]="'Equity 75000 to 99999'">Equity 75000 to 99999</mat-option>
						<mat-option [value]="'Equity 100000 to 149999'">Equity 100000 to 149999</mat-option>
						<mat-option [value]="'Equity 150000 to 199999'">Equity 150000 to 199999</mat-option>
						<mat-option [value]="'Equity 200000 to 249999'">Equity 200000 to 249999</mat-option>
						<mat-option [value]="'Equity 250000 to 499999'">Equity 250000 to 499999</mat-option>
						<mat-option [value]="'Equity 500000 to 749999'">Equity 500000 to 749999</mat-option>
						<mat-option [value]="'Equity 750000 to 999999	'">Equity 750000 to 999999	</mat-option>
						<mat-option [value]="'Equity 1000000 to 1999999'">Equity 1000000 to 1999999</mat-option>
					</mat-select> -->
					<input
					type="text"
					class="each-form-input"
					[(ngModel)]="
					client_data.home_equity_available_for_mortgage_in_dollars_actual
					"
					(keypress)="numberOnly($event)"
					/>
				</div>
			</div>
			<div class="col-md-4">
				<div class="each-form-input-section">
					<p class="each-form-input-label">Loan to Value in Percentage</p>
					<mat-select
					class="each-form-input"
					[(ngModel)]="client_data.loan_to_value_in_percentage"
					>
					<mat-option [value]="''">Select Loan to Value</mat-option>
					<mat-option [value]="'NO Loans'">NO Loans</mat-option>
					<mat-option [value]="'01 to 49'">01 to 49</mat-option>
					<mat-option [value]="'50 to 59'">50 to 59</mat-option>
					<mat-option [value]="'60 to 69'">60 to 69</mat-option>
					<mat-option [value]="'70 to 74'">70 to 74</mat-option>
					<mat-option [value]="'75 to 79'">75 to 79</mat-option>
					<mat-option [value]="'80 to 84'">80 to 84</mat-option>
					<mat-option [value]="'85 to 89'">85 to 89</mat-option>
					<mat-option [value]="'90 to 94'">90 to 94</mat-option>
					<mat-option [value]="'95 to 99'">95 to 99</mat-option>
					<mat-option [value]="'100 to 999'">100 to 999</mat-option>
				</mat-select>
			</div>
		</div>
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">Market Value of Home({{APP_CONSTANTS.CURRENCY_SYMBOL}})</p>
				<!-- <mat-select class="each-form-input" [(ngModel)]="client_data.market_value_of_home_in_dollars">
					<mat-option [value]="''">Select Market Value</mat-option>
					<mat-option [value]="'1000 to 24999'">1000 to 24999</mat-option>
					<mat-option [value]="'25000 to 49999'">25000 to 49999</mat-option>
					<mat-option [value]="'50000 to 74999'">50000 to 74999</mat-option>
					<mat-option [value]="'75000 to 99999'">75000 to 99999</mat-option>
					<mat-option [value]="'100000 to 124999'">100000 to 124999</mat-option>
					<mat-option [value]="'125000 to 149999'">125000 to 149999</mat-option>
					<mat-option [value]="'150000 to 174999'">150000 to 174999</mat-option>
					<mat-option [value]="'175000 to 199999'">175000 to 199999</mat-option>
					<mat-option [value]="'200000 to 224999'">200000 to 224999</mat-option>
					<mat-option [value]="'225000 to 249999'">225000 to 249999</mat-option>
					<mat-option [value]="'250000 to 274999'">250000 to 274999</mat-option>
					<mat-option [value]="'275000 to 299999'">275000 to 299999</mat-option>
					<mat-option [value]="'300000 to 349999'">300000 to 349999</mat-option>
					<mat-option [value]="'350000 to 399999'">350000 to 399999</mat-option>
					<mat-option [value]="'400000 to 449999'">400000 to 449999</mat-option>
					<mat-option [value]="'450000 to 499999'">450000 to 499999</mat-option>
					<mat-option [value]="'500000 to 749999'">500000 to 749999</mat-option>
					<mat-option [value]="'750000 to 999999'">750000 to 999999</mat-option>
					<mat-option [value]="'1000000 Plus'">1000000 Plus</mat-option>
				</mat-select> -->
				<input
				type="text"
				class="each-form-input"
				[(ngModel)]="
				client_data.market_value_of_home_in_dollars_actual
				"
				(keypress)="numberOnly($event)"
				/>
			</div>
		</div>
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">Liquid Net Worth({{APP_CONSTANTS.CURRENCY_SYMBOL}}) *</p>
				<input
				type="text"
				class="each-form-input"
				[(ngModel)]="client_data.net_worth_actual"
				(keypress)="numberOnly($event)"
				/>
			</div>
		</div>
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">Total Net Worth({{APP_CONSTANTS.CURRENCY_SYMBOL}})</p>
				<input
				type="text"
				class="each-form-input"
				[(ngModel)]="client_data.total_networth_actual"
				(keypress)="numberOnly($event)"
				/>
			</div>
		</div>
	</div>
</div>
<div class="each-form-section">
	<p class="each-form-heading-section">Additional Information</p>
	<div class="row">
		<div class="col-md-4">
			<div class="each-form-input-section">
				<!-- <p class="each-form-input-label">Source Type *</p> -->
				<p class="each-form-input-label">Data Source *</p>
				<mat-select
				class="each-form-input"
				[(ngModel)]="client_data.source_type_id"
				(selectionChange)="
				getDataTypeValues(client_data.source_type_id)
				"
				>
				<!-- <mat-option [value]="''">Select Source Type</mat-option> -->
				<mat-option [value]="''">Select Data Source Type</mat-option>
				<mat-option
				*ngFor="let data_type of data_type_list"
				[value]="data_type.id"
				>{{ data_type.name }}</mat-option
				>
			</mat-select>
		</div>
	</div>
	<div class="col-md-4" *ngIf="data_type_values_list.length > 0 && client_data.source_type_id != 4">
		<div class="each-form-input-section">
			<!-- <p class="each-form-input-label">Source *</p> -->
			<p class="each-form-input-label">Provider *</p>
			<mat-select
			class="each-form-input"
			[(ngModel)]="client_data.source_id"
			>
			<!-- <mat-option [value]="''">Select Source</mat-option> -->
			<mat-option [value]="''">Select Provider</mat-option>
			<mat-option
			*ngFor="let data_type_value of data_type_values_list"
			[value]="data_type_value.id"
			>{{ data_type_value.name }}</mat-option
			>
		</mat-select>
	</div>
</div>
<div class="col-md-4" *ngIf="client_data.source_type_id == 4">
	<div class="each-form-input-section">
		<p class="each-form-input-label">Referer *</p>
		<input
		type="text"
		class="each-form-input"
		[(ngModel)]="client_data.source"
		/>
	</div>
</div>
<!-- <div class="col-md-4">
	<div class="each-form-input-section">
		<p class="each-form-input-label">Type</p>
		<mat-select class="each-form-input" [(ngModel)]="client_data.type">
			<mat-option [value]="''">Select Type</mat-option>
			<mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
			<mat-option [value]="'Cross-Sell'">Cross-Sell</mat-option>
			<mat-option [value]="'Up-Sell'">Up-Sell</mat-option>
			<mat-option [value]="'New Acquisition'">New Acquisition</mat-option>
			<mat-option [value]="'Upside'">Upside</mat-option>
			<mat-option [value]="'Retention'">Retention</mat-option>
		</mat-select>
	</div>
</div> -->
<div class="col-md-4" *ngIf="clientOperationType != 'Add'">
	<div class="each-form-input-section">
		<p class="each-form-input-label">Segment</p>
		<input
		type="text"
		class="each-form-input"
		[(ngModel)]="client_data.segment"
		disabled
		readonly
		/>
	</div>
</div>
<div class="col-md-4">
	<div class="each-form-input-section">
		<p class="each-form-input-label">Last Date of Contact</p>
		<input
		type="text"
		class="each-form-input"
		placement="right"
		bsDatepicker
		[(ngModel)]="client_data.last_date_of_contact"
		[bsConfig]="{ dateInputFormat: 'YYYY/MM/DD' }"
		/>
	</div>
</div>
<div class="col-md-4">
	<div class="each-form-input-section">
		<p class="each-form-input-label">Business Plan *</p>
		<mat-select
		class="each-form-input"
		[(ngModel)]="client_data.business_plan_id"
		>
		<mat-option [value]="''">Select Business Plan</mat-option>
		<mat-option
		*ngFor="let plan of business_plan_list"
		[value]="plan.id"
		>{{ plan.name }}</mat-option
		>
	</mat-select>
</div>
</div>
</div>
<div class="row">
	<!-- <div class="col-md-4">
		<div class="each-form-input-section">
			<p class="each-form-input-label">Advisor</p>
			<mat-select class="each-form-input" [(ngModel)]="client_data.advisor_id">
				<mat-option [value]="''">Select Advisor</mat-option>
				<mat-option *ngFor="let advisor of advisor_list" [value]="advisor.id" (click)="client_data.advisor_manager_id = advisor.advisor_manager_id">{{advisor.first_name}} {{advisor.last_name}}</mat-option>
			</mat-select>
		</div>
	</div> -->
</div>
</div>
<div class="each-form-section">
	<p class="each-form-heading-section">Social Networking Information</p>
	<div class="row">
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">Linkedin</p>
				<input
				type="text"
				class="each-form-input"
				[(ngModel)]="client_data.linkedin_url"
				/>
			</div>
		</div>
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">Twitter</p>
				<input
				type="text"
				class="each-form-input"
				[(ngModel)]="client_data.twitter_url"
				/>
			</div>
		</div>
		<div class="col-md-4">
			<div class="each-form-input-section">
				<p class="each-form-input-label">Facebook</p>
				<input
				type="text"
				class="each-form-input"
				[(ngModel)]="client_data.facebook_url"
				/>
			</div>
		</div>
	</div>
</div>
</div>
</div>
<div class="modal-footer-section">
	<div class="py-4">
		<button
		class="add-client-button"
		(click)="clientOperationsProgress = clientOperationsProgress - 1"
		*ngIf="clientOperationsProgress > 1"
		>
		Back
	</button>
	<button
	class="add-client-button"
	(click)="validateClientForm()"
	*ngIf="clientOperationsProgress < 3"
	>
	Continue
</button>
<button
class="add-client-button"
*ngIf="clientOperationsProgress == 3"
(click)="validateClientForm()"
>
{{ clientOperationType }} Lead
</button>
<!-- <button class="add-client-button" *ngIf="clientOperationsProgress == 3" (click)="saveClientDetails()">
	{{clientOperationType}} Lead
</button> -->
<p class="error" *ngIf="client_error && clientOperationsProgress == 1">
	Please fill Mandatory fields : Lead ID, First Name, Email, Date of
	Birth, Status, State & Region to add a new Lead
</p>
<p class="error" *ngIf="client_error && clientOperationsProgress == 2">
	Please fill Mandatory fields : Individual Income in Dollars to add a new Lead
</p>
<p class="error" *ngIf="client_error && clientOperationsProgress == 3">
	Please fill Mandatory fields : Liquid Net Worth, Data Source & Business Plan to
	add a new Lead
</p>
</div>
</div>
</div>
</ng-template>


<!-- Move Record Modal HTML -->
<ng-template #moveRecordModal>
	<div class="page-modal-section">
		<div class="modal-heading-section client-view-heading-section">
			<span class="modal-heading">Change Stage</span>
			<span class="client-modal-icon" (click)="closeMoveRecordModal()">&times;</span>
		</div>
		<div class="modal-content-section" style="padding: 24px 0;">
			<div class="page-modal-input-section">
				<p class="page-modal-input-label">Select Stage</p>
				<mat-select class="page-modal-input" [(ngModel)]="move_record_stage">
					<mat-option [value]="''">Select Stage</mat-option>
					<mat-option *ngFor="let stage of stages_data" [value]="stage.id">{{stage.name}}</mat-option>
				</mat-select>
				<p class="page-modal-input-error" *ngIf="move_record_stage_error">Stage is Required.</p>
			</div>
			<div class="page-modal-input-section">
				<mat-checkbox [(ngModel)]="move_record_stage_activity_status">Mark Stage Activities as Not Required</mat-checkbox>
			</div>
		</div>
		<div class="modal-footer-section">
			<button class="page-modal-primary-button" (click)="changeClientStage()">Save</button>
			<button class="page-modal-secondary-button" (click)="closeMoveRecordModal()">Cancel</button>
		</div>
	</div>
</ng-template>

<ng-container *ngIf="show_user_profile">
	<ng-container *ngIf="user_profile_data.source_type_id != 1 ">
		<app-lead-profile [data]="user_profile_data" (profileClosed)="profileClosed($event)"></app-lead-profile>
	</ng-container>
	<ng-container *ngIf="user_profile_data.source_type_id == 1 ">
		<app-bank-customer-profile [data]="user_profile_data" (profileClosed)="profileClosed($event)"></app-bank-customer-profile>
	</ng-container>
</ng-container>

<ng-template #syncActivitiesModal>
	<div class="page-modal-section">
		<div class="modal-heading-section client-view-heading-section">
			<span class="modal-heading">Syncing Activities</span>
			<!-- <span class="client-modal-icon" (click)="closeSyncActivitiesModal()">&times;</span> -->
		</div>
		<div class="modal-content-section">
			<div class="page-modal-delete-description">
				<div>
					<img src="assets/sync-icon.png" class="rotating-image" />
				</div>
				<span>Syncing In Progress ...</span>
			</div>
		</div>
	</div>
</ng-template>
